import API from "../configs/axiosInstance";

const startRepositoryScan = (formData) => {
    return API({
        url: `/code-service/v1/repositories`,
        method: 'POST',
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

const updateRepository = (id, data) => {
    return API({
        url: `/code-service/v1/repositories/${id}`,
        method: 'PUT',
        data
    });
};

const getScannedRepositories = (data) => {
    return API({
        url: `/code-service/v1/repositories/pageable`,
        method: 'POST',
        ...data
    });
};

const startScanWithBranchName = (id, params) => {
    return API({
        url: `/code-service/v1//repositories/${id}/scan-by-branch-name?`,
        method: 'POST',
        params
    });
};

const exportRepositoriesCsv = (data) => {
    return API({
        url: `/code-service/v1/repositories/export-csv`,
        method: "POST",
        data: data,
        responseType: "blob",
    });
};

const getCodeDetailList = (data) => {
    return API({
        url: `/code-service/v1/repository-scan-reports/pageable`,
        method: 'POST',
        ...data
    });
};

const getCodeScanDetails = (id) => {
    return API({
        url: `/code-service/v1/repository-scan-reports/${id}`,
        method: 'GET',
    });
};



const codeService = {
    startRepositoryScan,
    updateRepository,
    getScannedRepositories,
    startScanWithBranchName,
    exportRepositoriesCsv,
    getCodeDetailList,
    getCodeScanDetails
};

export default codeService;